export default __webpack_public_path__ + "static/state1-136aed08a6edd4f928ca23ad7fe74c08.jpg";